import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';

class NewMechaScreenStore extends BaseStore {
  @observable isActive = false;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  use() {
    super.use();

    useMount(() => {});
  }
}

export default NewMechaScreenStore;
